import { render, staticRenderFns } from "./wrapper-component.vue?vue&type=template&id=a13fcd36&shadow"
import script from "./wrapper-component.vue?vue&type=script&lang=js&shadow"
export * from "./wrapper-component.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./wrapper-component.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports